import React from 'react';
import Card from '@material-ui/core/Card';
// import BoatIcon from '@material-ui/icons/DirectionsBoat';
import Typography from '@material-ui/core/Typography';
// import { Link } from 'react-router-dom';
import { useTranslate, Link } from 'react-admin';
import { ListItem, ListItemText, List/*, ListItemSecondaryAction*/ } from '@material-ui/core';
// import moment from 'moment';
import IconCitizen from './IconCitizen'
import { makeStyles } from '@material-ui/core/styles';

import CardIcon from './CardIcon';


const useStyles = makeStyles(
  theme => ({
    root: {
      width: '100%',
      maxWidth: 360,
      //backgroundColor: theme.palette.background.paper,
    },
    main: {
      flex: '1',
      marginRight: '1em',
      marginTop: 20,
    },
    main_mobile: {
      flex: '1',
      // marginRight: '1em',
      marginTop: 20,
    },
    card: {
      overflow: 'inherit',
      textAlign: 'right',
      padding: 16,
      minHeight: 52,
    },
    inline: {
      display: 'inline',
    },
    cardIcon: {
      float: 'left',
      margin: '-20px 20px 0 15px',
      zIndex: 100,
      borderRadius: 3,
      border: '2px solid #ff8400'
    }
  })
);

const PublicPastLaunches = ({ value, mobile, ...rest }) => {

  const classes = useStyles(rest);
  const translate = useTranslate();

  return (
    <div className={mobile ? classes.main_mobile : classes.main}>
      <CardIcon style={{
        // width: 30,
        // height: 30,
        // handColor: '#000',
        // wavyColor: '#000'
      }}
        cardIcon={classes.cardIcon}
        Icon={IconCitizen}
        bgColor="#f0e499"
      />
      <Card className={classes.card}>
        <Typography className={classes.title} color="textSecondary">
          {translate('containers.dashboard.past_launches')}
        </Typography>

        <Typography type="headline" component="h2">
          {(value && value.length) || 0}
        </Typography>

        {value && value.map(launch => (
          <Link to={{
            pathname: `/history/${launch.id}`,
            launch: launch
          }}
            // params= { {launch} }
            key={`${launch.launch_id}`}
          >
            <List className={classes.root}>
              <ListItem button
                className={classes.content}
              >
                <ListItemText
                  primary={`${launch.name} - ${launch.description}`}
                  secondary={
                    <React.Fragment>
                      <Typography
                        component="span"
                        variant="body2"
                        className={classes.inline}
                        color="textPrimary"
                      >
                        {'Started: '}
                      </Typography>
                      {/* {moment(launch.begintimestamp).utc().format('DD-MM-YYYY, HH:mm:ss') + ' GMT'} */}
                      {new Date(launch.begintimestamp).toLocaleString()}
                      <br />
                      <Typography
                        component="span"
                        variant="body2"
                        className={classes.inline}
                        color="textPrimary"
                      >
                        {'Ended: '}
                      </Typography>
                      {/* {moment(launch.endtimestamp).utc().format('DD-MM-YYYY, HH:mm:ss') + ' GMT'} */}
                      {new Date(launch.endtimestamp).toLocaleString()}
                    </React.Fragment>
                  }
                />
              </ListItem>
            </List>
          </Link>
        ))}
      </Card>
    </div>
  )
};

export default PublicPastLaunches;